import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {Select, MenuItem, FormControl, InputLabel} from '@mui/material';
import { AppDispatch, RootState } from '../../../redux/store';
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import MultiSelectUserRole from "../../../components/common/UserSelect/MultiSelectUserRole";
import {assignRole} from "../../../redux/actions/roles.actions";
import {fetchDealershipUsers} from "../../../redux/actions/dealership.actions";
import {useSearchParams} from "react-router-dom";
import ModalShell, { ModalLoading } from "../../../components/common/Modals/ModalShell";

const AddStaffModal: React.FC<ModalProps> = ({open, setOpen, object_id}) => {
    const dealer_id = object_id;
    const dispatch = useDispatch<AppDispatch>();
    const [searchParams, setSearchParams] = useSearchParams();
    const [selected, setSelected] = useState<any[]>([]);
    const [role, setRole] = useState('sales');
    const [isConfirmed, setIsConfirmed] = useState(false);

    const {loading} = useSelector((state: RootState) => state.users);
    const {error:roleError} = useSelector((state: RootState) => state.roleUsers);


    const handleConfirm = async () => {
        setIsConfirmed(true);
        await dispatch(assignRole({role_id: role, users: selected}));
    }

    const handleReset = () => {
        setSelected([]);
        setRole('sales');
        setIsConfirmed(false);
    }

    const handleClose = ()=> {
        handleReset();
        setOpen(false);

        if (!roleError && !loading && isConfirmed){
            if (dealer_id) {
                dispatch(fetchDealershipUsers({id:dealer_id, params:searchParams.toString()}));
            }
        }
    }

    const succeeded = !loading && !roleError && isConfirmed;
    const userCount = `${selected.length} ${selected.length===1 ? `user` : `users`}`;

    return (
      <ModalShell
        open={open}
        onClose={handleClose}
        size={loading || roleError || succeeded ? "sm" : "md"}
        tone={loading ? undefined : roleError ? "error" : succeeded ? "success" : undefined}
        title={loading ? "Loading…" : roleError ? "An error occurred" : succeeded ? "Users assigned" : "Add users to staff"}
        subtitle={!loading && !roleError && !succeeded ? "This action will change the selected users' role." : undefined}
        actions={loading || roleError ?
          <button className="btn" onClick={handleClose}>Close</button>
          : succeeded ?
          <>
            <button className="btn dlg-actions-start" onClick={handleReset}>Add more users</button>
            <button className="btn btn-primary" onClick={handleClose}>Done</button>
          </>
          :
          <>
            <button className="btn" onClick={handleClose}>Cancel</button>
            <button className="btn btn-primary" disabled={selected.length===0} onClick={handleConfirm}>Confirm</button>
          </>
        }
      >
        {loading ?
          <ModalLoading/>
          : roleError ?
          <p>{roleError}</p>
          : succeeded ?
          <p>{`${userCount} successfully assigned to the ${role} role.`}</p>
          :
          <>
            <FormControl fullWidth size="small">
              <InputLabel>Role</InputLabel>
              <Select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                label="Role"
              >
                <MenuItem value="sales">Sales</MenuItem>
                <MenuItem value="technician">Technician</MenuItem>
              </Select>
            </FormControl>

            <div className="dlg-section">
              <span className="dlg-label">{`Add ${userCount} to the ${role} role`}</span>
              <MultiSelectUserRole checked={selected} setChecked={setSelected} dealership_id={dealer_id} role={role}/>
            </div>
          </>
        }
      </ModalShell>
  )
};

export default AddStaffModal;